<div class="container mt-3">
  <p-confirmpopup></p-confirmpopup>
  <form [formGroup]="absenceForm" (ngSubmit)="save()">
    <h5>Neue Fehlzeit</h5>
    <div class="p-fluid grid mt-3">
      <div class="field col-12 md:col-6">
        <p-floatlabel>
          <p-date-picker inputId="date" class="w-100" dateFormat="dd.mm.yy"
                         formControlName="date"></p-date-picker>
          <label for="date">Datum</label>
        </p-floatlabel>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatlabel>
          <p-select class="w-100" [options]="absenceStatuses" formControlName="absence_status" optionLabel="title"
                    inputId="absence_status" optionValue="status" [showClear]="true"></p-select>
          <label for="absence_status">Status</label>
        </p-floatlabel>
      </div>

      <div class="field col-12">
        <p-floatlabel variant="in">
          <textarea pTextarea id="comment" class="w-full" formControlName="comment"></textarea>
          <label for="comment">Bemerkung</label>
        </p-floatlabel>
      </div>
    </div>
    <div class="w-100 d-flex justify-content-end mb-3">
      <p-button type="submit" label="FEHLZEIT SPEICHERN" icon="pi pi-save" [rounded]="true"></p-button>
    </div>
  </form>

  <p-table [value]="absenceService.absences" [loading]="loading">
    <ng-template pTemplate="header">
      <tr>
        <th>Datum</th>
        <th>Status</th>
        <th>Bemerkung</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-absence>
      <tr>
        <td>{{ absence.date | date : "dd.MM.yyyy" }}</td>
        <td>
          <p-select appendTo="body" class="w-100" [options]="absenceStatuses" optionLabel="title"
                    [ngModel]="absence.absence_status"
                    inputId="absence_status" optionValue="status" (onChange)="update(absence, $event)"></p-select>
        </td>
        <td>{{ absence.comment }}</td>
        <td>
          <p-button icon="pi pi-times" (click)="delete(absence.id, $event)" [rounded]="true"
                    severity="danger" [outlined]="true"></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5">Keine Fehlzeiten</td>
      </tr>
    </ng-template>
  </p-table>


</div>
